export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';

export const GET_OVERVIEW_REQUEST = 'GET_OVERVIEW_REQUEST';
export const GET_OVERVIEW_SUCCESS = 'GET_OVERVIEW_SUCCESS';
export const GET_OVERVIEW_FAILURE = 'GET_OVERVIEW_FAILURE';

export const GET_OPERATIONS_REQUEST = 'GET_OPERATIONS_REQUEST';
export const GET_OPERATIONS_SUCCESS = 'GET_OPERATIONS_SUCCESS';
export const GET_OPERATIONS_FAILURE = 'GET_OPERATIONS_FAILURE';
export const SET_OPERATIONS = 'SET_OPERATIONS';

export const GET_INVENTORY_REQUEST = 'GET_INVENTORY_REQUEST';
export const GET_INVENTORY_SUCCESS = 'GET_INVENTORY_SUCCESS';
export const GET_INVENTORY_FAILURE = 'GET_INVENTORY_FAILURE';

export const GET_TYPE_IDS_REQUEST = 'GET_TYPE_IDS_REQUEST';
export const GET_TYPE_IDS_SUCCESS = 'GET_TYPE_IDS_SUCCESS';
export const GET_TYPE_IDS_FAILURE = 'GET_TYPE_IDS_FAILURE';

export const GET_INVENTORY_ITEMS_REQUEST = 'GET_INVENTORY_ITEMS_REQUEST';
export const GET_INVENTORY_ITEMS_SUCCESS = 'GET_INVENTORY_ITEMS_SUCCESS';
export const GET_INVENTORY_ITEMS_FAILURE = 'GET_INVENTORY_ITEMS_FAILURE';

export const GET_TASK_STATUSES_REQUEST = 'GET_TASK_STATUSES_REQUEST';
export const GET_TASK_STATUSES_SUCCESS = 'GET_TASK_STATUSES_SUCCESS';
export const GET_TASK_STATUSES_FAILURE = 'GET_TASK_STATUSES_FAILURE';

export const setDashboardFilters = (tab, filters = {}) => ({
    type: SET_DASHBOARD_FILTERS,
    payload: { tab, filters }
});

export const getOverviewRequest = (filters = {}) => ({
    type: GET_OVERVIEW_REQUEST,
    payload: { filters }
});

export const getOverviewSuccess = ({ summary, kanban, series, companies, reasons }) => ({
    type: GET_OVERVIEW_SUCCESS,
    payload: { summary, kanban, series, companies, reasons }
});

export const getOverviewFailure = err => ({
    type: GET_OVERVIEW_FAILURE,
    error: err
});

export const getOperationsRequest = (filters = {}) => ({
    type: GET_OPERATIONS_REQUEST,
    payload: { filters }
});

export const getOperationsSuccess = (operations, total = 0) => ({
    type: GET_OPERATIONS_SUCCESS,
    payload: { operations, total }
});

export const getOperationsFailure = err => ({
    type: GET_OPERATIONS_FAILURE,
    error: err
});

export const setOperations = (operations = [], total = 0) => ({
    type: SET_OPERATIONS,
    payload: { operations, total }
});

export const getInventoryRequest = (filters = {}) => ({
    type: GET_INVENTORY_REQUEST,
    payload: { filters }
});

export const getInventorySuccess = inventory => ({
    type: GET_INVENTORY_SUCCESS,
    payload: { inventory }
});

export const getInventoryFailure = err => ({
    type: GET_INVENTORY_FAILURE,
    error: err
});

export const getTypeIdsRequest = () => ({
    type: GET_TYPE_IDS_REQUEST
});

export const getTypeIdsSuccess = typeIds => ({
    type: GET_TYPE_IDS_SUCCESS,
    payload: { typeIds }
});

export const getTypeIdsFailure = err => ({
    type: GET_TYPE_IDS_FAILURE,
    error: err
});

export const getInventoryItemsRequest = (type, filters = {}) => ({
    type: GET_INVENTORY_ITEMS_REQUEST,
    payload: { type, filters }
});

export const getInventoryItemsSuccess = data => ({
    type: GET_INVENTORY_ITEMS_SUCCESS,
    payload: { data }
});

export const getInventoryItemsFailure = err => ({
    type: GET_INVENTORY_ITEMS_FAILURE,
    error: err
});

export const getTaskStatusesRequest = (type = 'installations') => ({
    type: GET_TASK_STATUSES_REQUEST,
    payload: { type }
});

export const getTaskStatusesSuccess = (statuses, type) => ({
    type: GET_TASK_STATUSES_SUCCESS,
    payload: { statuses, type }
});

export const getTaskStatusesFailure = err => ({
    type: GET_TASK_STATUSES_FAILURE,
    error: err
});
